module.exports = __webpack_public_path__ + "static/media/studiuje-it.b8c7d6f6.webp";